export const getTestId = (suffix, dataTestId) => (dataTestId ? `${dataTestId}-${suffix}` : suffix);
